/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Faq_1_QInputs */

const en_mk_faq_1_q = /** @type {(inputs: Mk_Faq_1_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Do I need to install anything?`)
};

const id_mk_faq_1_q = /** @type {(inputs: Mk_Faq_1_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apakah saya perlu instal sesuatu?`)
};

/**
* | output |
* | --- |
* | "Do I need to install anything?" |
*
* @param {Mk_Faq_1_QInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_faq_1_q = /** @type {((inputs?: Mk_Faq_1_QInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Faq_1_QInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_faq_1_q(inputs)
	return en_mk_faq_1_q(inputs)
});